import { cn } from '@src/components/ui';
import { useSidebar } from '@src/context/hooks';


const itemClass = 'group relative flex h-[38px] w-full items-center gap-[11px] rounded-lg px-[11px] '
  + 'text-[13px] font-medium text-ink-muted outline-none transition-colors hover:bg-surface-2 hover:text-ink '
  + 'focus-visible:ring-focus [&_svg]:size-[17px] [&_svg]:shrink-0';

/**
 * Generic sidebar row (.pen Sidebar nav rows: 38px, 8px radius, 17px icon).
 * Renders `as` (a Link for nav, a button for actions). Collapses to icon-only
 * with the label as a native tooltip. `disabled` rows are inert coming-soon
 * placeholders for pages from later milestones.
 */
function SidebarItem(props) {
  const { as: Comp = 'button', icon, label, disabled, className, ...restProps } = props;

  const { isCollapsed } = useSidebar();

  if (disabled) {
    return (
      <li>
        <span
          title={typeof disabled === 'string' ? disabled : 'Coming soon'}
          className={cn(
            itemClass,
            'cursor-default text-ink-subtle hover:bg-transparent hover:text-ink-subtle',
          )}
        >
          <span className="flex shrink-0 items-center justify-center">{icon}</span>
          {!isCollapsed ? <span className="truncate">{label}</span> : null}
        </span>
      </li>
    );
  }

  const isButton = Comp === 'button';

  return (
    <li>
      <Comp
        className={cn(itemClass, className)}
        title={isCollapsed ? label : undefined}
        {...(isButton ? { type: 'button' } : {})}
        {...restProps}
      >
        <span className="flex shrink-0 items-center justify-center">{icon}</span>

        {!isCollapsed
          ? (
            <span className="truncate">{label}</span>
          )
          : null}
      </Comp>
    </li>
  );
}

SidebarItem.displayName = 'SidebarItem';
export default SidebarItem;
